// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type DeleteCampaignMessageMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type DeleteCampaignMessageMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { messageAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignMessageActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignMessageActionModelAsEditor, 'id' | 'delete'>
      )> }
    )> }
  )> }
);

export type DeleteTopicShareActionMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type DeleteTopicShareActionMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { topicShareAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignTopicShareActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignTopicShareActionModelAsEditor, 'id' | 'delete'>
      )> }
    )> }
  )> }
);

export type DeleteSurveyShareActionMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type DeleteSurveyShareActionMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { surveyShareAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignSurveyShareActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignSurveyShareActionModelAsEditor, 'id' | 'delete'>
      )> }
    )> }
  )> }
);

export type DeletePathwayShareActionMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type DeletePathwayShareActionMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { pathwayShareAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignPathwayShareActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignPathwayShareActionModelAsEditor, 'id' | 'delete'>
      )> }
    )> }
  )> }
);

export type DeleteCampaignEmailMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type DeleteCampaignEmailMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { emailAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignEmailActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignEmailActionModelAsEditor, 'id' | 'delete'>
      )> }
    )> }
  )> }
);

export type DeleteCampaignBannerMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type DeleteCampaignBannerMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { banner?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignBannerModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignBannerModelAsEditor, 'id' | 'delete'>
      )> }
    )> }
  )> }
);

export type DeleteCertificationShareActionMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type DeleteCertificationShareActionMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { certificationShareAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignCertificationShareActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignCertificationShareActionModelAsEditor, 'id' | 'delete'>
      )> }
    )> }
  )> }
);


export const DeleteCampaignMessageDocument = gql`
    mutation deleteCampaignMessage($id: PositiveInt!, $campaignId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      messageAction(id: $id) {
        id
        delete
      }
    }
  }
}
    `;
export type DeleteCampaignMessageMutationFn = Apollo.MutationFunction<DeleteCampaignMessageMutation, DeleteCampaignMessageMutationVariables>;

/**
 * __useDeleteCampaignMessageMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignMessageMutation, { data, loading, error }] = useDeleteCampaignMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useDeleteCampaignMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCampaignMessageMutation, DeleteCampaignMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCampaignMessageMutation, DeleteCampaignMessageMutationVariables>(DeleteCampaignMessageDocument, options);
      }
export type DeleteCampaignMessageMutationHookResult = ReturnType<typeof useDeleteCampaignMessageMutation>;
export type DeleteCampaignMessageMutationResult = Apollo.MutationResult<DeleteCampaignMessageMutation>;
export type DeleteCampaignMessageMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignMessageMutation, DeleteCampaignMessageMutationVariables>;
export const DeleteTopicShareActionDocument = gql`
    mutation deleteTopicShareAction($id: PositiveInt!, $campaignId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      topicShareAction(id: $id) {
        id
        delete
      }
    }
  }
}
    `;
export type DeleteTopicShareActionMutationFn = Apollo.MutationFunction<DeleteTopicShareActionMutation, DeleteTopicShareActionMutationVariables>;

/**
 * __useDeleteTopicShareActionMutation__
 *
 * To run a mutation, you first call `useDeleteTopicShareActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTopicShareActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTopicShareActionMutation, { data, loading, error }] = useDeleteTopicShareActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useDeleteTopicShareActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTopicShareActionMutation, DeleteTopicShareActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTopicShareActionMutation, DeleteTopicShareActionMutationVariables>(DeleteTopicShareActionDocument, options);
      }
export type DeleteTopicShareActionMutationHookResult = ReturnType<typeof useDeleteTopicShareActionMutation>;
export type DeleteTopicShareActionMutationResult = Apollo.MutationResult<DeleteTopicShareActionMutation>;
export type DeleteTopicShareActionMutationOptions = Apollo.BaseMutationOptions<DeleteTopicShareActionMutation, DeleteTopicShareActionMutationVariables>;
export const DeleteSurveyShareActionDocument = gql`
    mutation deleteSurveyShareAction($id: PositiveInt!, $campaignId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      surveyShareAction(id: $id) {
        id
        delete
      }
    }
  }
}
    `;
export type DeleteSurveyShareActionMutationFn = Apollo.MutationFunction<DeleteSurveyShareActionMutation, DeleteSurveyShareActionMutationVariables>;

/**
 * __useDeleteSurveyShareActionMutation__
 *
 * To run a mutation, you first call `useDeleteSurveyShareActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSurveyShareActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSurveyShareActionMutation, { data, loading, error }] = useDeleteSurveyShareActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useDeleteSurveyShareActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteSurveyShareActionMutation, DeleteSurveyShareActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteSurveyShareActionMutation, DeleteSurveyShareActionMutationVariables>(DeleteSurveyShareActionDocument, options);
      }
export type DeleteSurveyShareActionMutationHookResult = ReturnType<typeof useDeleteSurveyShareActionMutation>;
export type DeleteSurveyShareActionMutationResult = Apollo.MutationResult<DeleteSurveyShareActionMutation>;
export type DeleteSurveyShareActionMutationOptions = Apollo.BaseMutationOptions<DeleteSurveyShareActionMutation, DeleteSurveyShareActionMutationVariables>;
export const DeletePathwayShareActionDocument = gql`
    mutation deletePathwayShareAction($id: PositiveInt!, $campaignId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      pathwayShareAction(id: $id) {
        id
        delete
      }
    }
  }
}
    `;
export type DeletePathwayShareActionMutationFn = Apollo.MutationFunction<DeletePathwayShareActionMutation, DeletePathwayShareActionMutationVariables>;

/**
 * __useDeletePathwayShareActionMutation__
 *
 * To run a mutation, you first call `useDeletePathwayShareActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePathwayShareActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePathwayShareActionMutation, { data, loading, error }] = useDeletePathwayShareActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useDeletePathwayShareActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePathwayShareActionMutation, DeletePathwayShareActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePathwayShareActionMutation, DeletePathwayShareActionMutationVariables>(DeletePathwayShareActionDocument, options);
      }
export type DeletePathwayShareActionMutationHookResult = ReturnType<typeof useDeletePathwayShareActionMutation>;
export type DeletePathwayShareActionMutationResult = Apollo.MutationResult<DeletePathwayShareActionMutation>;
export type DeletePathwayShareActionMutationOptions = Apollo.BaseMutationOptions<DeletePathwayShareActionMutation, DeletePathwayShareActionMutationVariables>;
export const DeleteCampaignEmailDocument = gql`
    mutation deleteCampaignEmail($id: PositiveInt!, $campaignId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      emailAction(id: $id) {
        id
        delete
      }
    }
  }
}
    `;
export type DeleteCampaignEmailMutationFn = Apollo.MutationFunction<DeleteCampaignEmailMutation, DeleteCampaignEmailMutationVariables>;

/**
 * __useDeleteCampaignEmailMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignEmailMutation, { data, loading, error }] = useDeleteCampaignEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useDeleteCampaignEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCampaignEmailMutation, DeleteCampaignEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCampaignEmailMutation, DeleteCampaignEmailMutationVariables>(DeleteCampaignEmailDocument, options);
      }
export type DeleteCampaignEmailMutationHookResult = ReturnType<typeof useDeleteCampaignEmailMutation>;
export type DeleteCampaignEmailMutationResult = Apollo.MutationResult<DeleteCampaignEmailMutation>;
export type DeleteCampaignEmailMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignEmailMutation, DeleteCampaignEmailMutationVariables>;
export const DeleteCampaignBannerDocument = gql`
    mutation deleteCampaignBanner($id: PositiveInt!, $campaignId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      banner(id: $id) {
        id
        delete
      }
    }
  }
}
    `;
export type DeleteCampaignBannerMutationFn = Apollo.MutationFunction<DeleteCampaignBannerMutation, DeleteCampaignBannerMutationVariables>;

/**
 * __useDeleteCampaignBannerMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignBannerMutation, { data, loading, error }] = useDeleteCampaignBannerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useDeleteCampaignBannerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCampaignBannerMutation, DeleteCampaignBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCampaignBannerMutation, DeleteCampaignBannerMutationVariables>(DeleteCampaignBannerDocument, options);
      }
export type DeleteCampaignBannerMutationHookResult = ReturnType<typeof useDeleteCampaignBannerMutation>;
export type DeleteCampaignBannerMutationResult = Apollo.MutationResult<DeleteCampaignBannerMutation>;
export type DeleteCampaignBannerMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignBannerMutation, DeleteCampaignBannerMutationVariables>;
export const DeleteCertificationShareActionDocument = gql`
    mutation deleteCertificationShareAction($id: PositiveInt!, $campaignId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      certificationShareAction(id: $id) {
        id
        delete
      }
    }
  }
}
    `;
export type DeleteCertificationShareActionMutationFn = Apollo.MutationFunction<DeleteCertificationShareActionMutation, DeleteCertificationShareActionMutationVariables>;

/**
 * __useDeleteCertificationShareActionMutation__
 *
 * To run a mutation, you first call `useDeleteCertificationShareActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCertificationShareActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCertificationShareActionMutation, { data, loading, error }] = useDeleteCertificationShareActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useDeleteCertificationShareActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCertificationShareActionMutation, DeleteCertificationShareActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCertificationShareActionMutation, DeleteCertificationShareActionMutationVariables>(DeleteCertificationShareActionDocument, options);
      }
export type DeleteCertificationShareActionMutationHookResult = ReturnType<typeof useDeleteCertificationShareActionMutation>;
export type DeleteCertificationShareActionMutationResult = Apollo.MutationResult<DeleteCertificationShareActionMutation>;
export type DeleteCertificationShareActionMutationOptions = Apollo.BaseMutationOptions<DeleteCertificationShareActionMutation, DeleteCertificationShareActionMutationVariables>;